import { getFirestore, } from "firebase/firestore";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDR1mFKtuUyOJA9DQPvyrbGkISWuGjvWEs",
  authDomain: "tellstory-bf9ee.firebaseapp.com",
  projectId: "tellstory-bf9ee",
  storageBucket: "tellstory-bf9ee.appspot.com",
  messagingSenderId: "456167122398",
  appId: "1:456167122398:web:9b13b652dfc478aa36694f"
};

export const FirebaseApp = initializeApp(firebaseConfig);
export const FirestoreDb =  getFirestore(FirebaseApp);
export const db =  getFirestore();
